import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, sendSms } from './modules'
import { getCaptcha } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const MessagePay = Loadable({
    loader: () => import('./MessagePay'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          paymentsMessagePayState: state.paymentsMessagePayState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          sendSms,
          getCaptcha,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/message-pay`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <MessagePay {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
